export const PM_TICKET = "PM_TICKET";
export const PM_TICKET_DETAILS = "PM_TICKET_DETAILS";
export const PM_ASSIGNEE = "PM_ASSIGNEE";
export const PM_TICKET_ASSIGNEE = "PM_TICKET_ASSIGNEE";
export const PM_TICKET_STATUS = "PM_TICKET_STATUS";
export const PM_TICKET_FILTER = "PM_TICKET_FILTER";
export const PM_SLOT_DETAILS = "PM_SLOT_DETAILS";
export const PROJECT_PM_TICKET_DETAILS="PROJECT_PM_TICKET_DETAILS"

